import React from 'react'
import COLORS from '../../styles/colors'
import { SVGProps } from '../../types/svg'

const defaultSize = {
  width: 13,
  height: 13,
}

const House = ({ style = {}, color = COLORS.brand.primaryDark, className = '' }: SVGProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 40.647 40.647'
    className={className}
  >
    <g fill={color}>
      <path
        d='M39.852,39.06H36.359V32.788a.794.794,0,0,0-1.588,0V39.06H25.245V23.976a.794.794,0,0,0-.794-.794H16.195a.794.794,0,0,0-.794.794V39.06H5.875V21.118H6.18a.794.794,0,0,0,.561-.233L20.323,7.3,33.9,20.886a.794.794,0,0,0,.561.233h.305v5.954a.794.794,0,0,0,1.588,0V21.118h3.493a.794.794,0,0,0,.561-1.355L20.884.234a.794.794,0,0,0-1.123,0L12.3,7.7a.794.794,0,0,0,1.123,1.123l6.9-6.9L37.936,19.531H34.8L20.884,5.62a.794.794,0,0,0-1.123,0L5.851,19.531H2.71l6.266-6.266a.794.794,0,0,0-1.123-1.123L.232,19.763a.794.794,0,0,0,.561,1.355H4.287V39.06H.794a.794.794,0,0,0,0,1.588H39.852a.794.794,0,1,0,0-1.588Zm-16.2,0H16.989V24.77h6.669Z'
        transform='translate(0 -0.001)'
      />
      <g transform='translate(26.992 23.181)'>
        <path
          d='M345.241,292h-4.446a.794.794,0,0,0-.794.794v7.939a.794.794,0,0,0,.794.794h4.446a.794.794,0,0,0,.794-.794V292.8A.794.794,0,0,0,345.241,292Zm-.794,7.939h-2.858V293.59h2.858Z'
          transform='translate(-340.001 -292.002)'
        />
      </g>
      <g transform='translate(7.621 23.181)'>
        <path
          d='M101.241,292H96.795A.794.794,0,0,0,96,292.8v7.939a.794.794,0,0,0,.794.794h4.446a.794.794,0,0,0,.794-.794V292.8A.794.794,0,0,0,101.241,292Zm-.794,7.939H97.589V293.59h2.858Z'
          transform='translate(-96.001 -292.002)'
        />
      </g>
      <g transform='translate(16.672 13.045)'>
        <path
          d='M213.653,164.322a3.652,3.652,0,1,0,3.652,3.652A3.656,3.656,0,0,0,213.653,164.322Zm0,5.716a2.064,2.064,0,1,1,2.064-2.064A2.066,2.066,0,0,1,213.653,170.038Z'
          transform='translate(-210.001 -164.322)'
        />
      </g>
      <g transform='translate(18.021 31.12)'>
        <path
          d='M228.356,392.235a.793.793,0,1,0,.233.561A.8.8,0,0,0,228.356,392.235Z'
          transform='translate(-227.001 -392.002)'
        />
      </g>
      <g transform='translate(9.765 9.765)'>
        <path
          d='M124.356,123.235a.793.793,0,1,0,.233.561A.8.8,0,0,0,124.356,123.235Z'
          transform='translate(-123.001 -123.002)'
        />
      </g>
      <g transform='translate(34.772 28.923)'>
        <path
          d='M439.356,364.564a.794.794,0,1,0,.233.561A.8.8,0,0,0,439.356,364.564Z'
          transform='translate(-438.001 -364.331)'
        />
      </g>
    </g>
  </svg>
)

export default House
